import React from 'react';

export type TelemetryContext = SharedDialogTelemetry & OpalTelemetryContext;

export type SharedDialogTelemetry = {
  siteLuid?: string;
  telemetryEnvironment?: TelemetryEnvironment;
  appSessionId?: string;
  dialogSessionId?: string; // TODO: move this into description dialog
  dialogReleaseVersion?: string; // TODO: move this into description dialog
}

export type OpalTelemetryContext = {
  site_role_id?: number;
  site_role?: string;
  session_id?: string;
  user_luid?: string;
  site_luid?: string;
}

export enum TelemetryEnvironment {
  Disabled = 'Disabled',
  Desktop = 'Desktop',
  Server = 'Server',
  Online = 'Online',
  Prep = 'Prep',
}

export function getTelemetryEnvironmentEnumValueFromString(telemetryEnvironment: string): TelemetryEnvironment {
  // If we have a string representation, e.g., 'Desktop', which we will when it comes from a presmodel, we can do this:
  let enumValue: TelemetryEnvironment | undefined = TelemetryEnvironment[telemetryEnvironment as keyof typeof TelemetryEnvironment];
  if (!enumValue) {
    // Else we should have an index, e.g., 2, which we will when it comes from Script#.
    // We can technically do:
    //    TelemetryEnvironment[TelemetryEnvironment[index]]
    // however that involves:
    //    unsafe assignment of an 'any' value because expression of type 'any' can't
    //    be used to index type 'typeof TelemetryEnvironment'
    // Also, Script# knows this as an enum, which at runtime becomes a number. Even though our props
    // call it a string. So we have to do some contortions to make this mostly-safe switch statement work:
    const valueAsNumber: number = parseInt(telemetryEnvironment, 10);
    switch (valueAsNumber) {
      case 0:
        enumValue = TelemetryEnvironment.Disabled;
        break;
      case 1:
        enumValue = TelemetryEnvironment.Desktop;
        break;
      case 2:
        enumValue = TelemetryEnvironment.Server;
        break;
      case 3:
        enumValue = TelemetryEnvironment.Online;
        break;
      case 4:
        enumValue = TelemetryEnvironment.Prep;
        break;
      default:
        throw new RangeError(`Don't know how to handle TelemetryEnvironment value of ${telemetryEnvironment}`);
    }
  }

  return enumValue;
}

export const ReactTelemetryContext = React.createContext<TelemetryContext>({
  telemetryEnvironment: TelemetryEnvironment.Disabled,
});
